const CheckoutDataCalculator = {
    calculateFormToStep: (order, step) => {
        let formObject = {};

        // TODO: Implement here the calculation for other steps if needed.
        if (step === 'address') {
            formObject = CheckoutDataCalculator.calculateFormToAddress(order);
        }

        return formObject;
    },

    calculateFormToAddress: (order) => {
        const propertiesFromOrder = ['email', 'email_receiver'];
        const propertiesFromAddress = ['firstname', 'lastname', 'address1', 'address2', 'city', 'phone', 'zipcode', 'state_name', 'country_iso'];

        return {
            save_user_address: true,
            order: {
                ...CheckoutDataCalculator.copyObject(order, propertiesFromOrder),
                bill_address_attributes: CheckoutDataCalculator.copyObject(order.bill_address, propertiesFromAddress),
                ship_address_attributes: CheckoutDataCalculator.copyObject(order.ship_address, propertiesFromAddress),
            },
        };
    },

    copyObject: (inputObject, attributes) => {
        const outputObject = {};
        attributes.forEach((key) => {
            outputObject[key] = inputObject[key];
        });
        return outputObject;
    },
};

export default CheckoutDataCalculator;



/** WEBPACK FOOTER **
 ** ./src/services/checkout-data-calculator.js
 **/